module.exports = __webpack_public_path__ + "static/media/Getting_Lost.9997acbd.mp3";